import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  Uploader,
  UploadingFile,
  UPLOADER_VARIANT_UPLOADING,
  UPLOADER_VARIANT_DANGER,
  UPLOADER_VARIANT_UPLOADED,
  UPLOADER_VARIANT_DEFAULT,
  Icon60CancelCircle,
  FormElement,
  Text,
  TEXT_VARIANT_BOLD,
  Flex,
  FlexItem
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { fileValidState, pageState } from '../recoil/state/page'
import { FILE_ACCEPT, getExtension } from '../const'
import { uploadFileCallback } from '../recoil/callbacks/callbacks'
import styled from '@emotion/styled'

const StyledUploadedHint = styled.div`
  & > :last-child {
    font-size: 21px;

    svg path {
      stroke: var(--java);
      stroke-width: 2px;
    }
    & > :hover {
      svg path {
        stroke: var(--blue-chill);
      }
      cursor: ${({ showLink }) => (showLink ? 'default' : 'pointer')};
    }
  }
`

const InputFile = () => {
  const intl = useIntl()
  const [{ file, variant, warning }, setFileState] = useRecoilState(pageState)
  const isValidFile = useRecoilValue(fileValidState)
  const uploadFile = useRecoilCallback(uploadFileCallback, [])

  const defaultInner = (
    <span>
      {intl.formatMessage({
        id: 'Load.ContentsSouces.FileUploaderTitle'
      })}{' '}
      <label htmlFor='input-email-file-id'>
        {intl.formatMessage({
          id: 'Load.EmailMessageImport.fileUploaderBrowseLabel'
        })}
      </label>
    </span>
  )

  const value =
    variant === UPLOADER_VARIANT_UPLOADING ? (
      <UploadingFile
        name={file.name}
        size={`${intl.formatNumber(file.size)} KB`}
      />
    ) : (
      undefined
    )

  let hint =
    variant === UPLOADER_VARIANT_DANGER ? (
      intl
        .formatMessage({
          id: 'Load.EmailMessageImport.AttachmentsExceededTotalSize'
        })
        .replace('{Y}', '20')
    ) : variant === UPLOADER_VARIANT_UPLOADED ? (
      <StyledUploadedHint showLink={warning}>
        <Flex alignItems='center' justifyContent='center'>
          <Text variant={TEXT_VARIANT_BOLD}>{file && file.name}</Text>

          <FlexItem margin='0 0 0 8px'>
            <div
              onClick={() => {
                if (!warning) {
                  setFileState(prev => ({
                    ...prev,
                    variant: UPLOADER_VARIANT_DEFAULT,
                    file: undefined
                  }))
                }
              }}
            >
              {!warning && <Icon60CancelCircle />}
            </div>
          </FlexItem>
        </Flex>
      </StyledUploadedHint>
    ) : (
      intl.formatMessage({
        id: 'Load.EmailMessageImport.fileUploaderDescription'
      })
    )

  useEffect(() => {
    if (file) {
      if (isValidFile) {
        // upload
        setFileState(prev => ({
          ...prev,
          variant: UPLOADER_VARIANT_UPLOADING
        }))
      } else {
        setFileState(prev => ({
          ...prev,
          variant: UPLOADER_VARIANT_DANGER
        }))
        hint = intl
          .formatMessage({
            id: 'Load.EmailMessageImport.AttachmentsExceededTotalSize' //
          })
          .replace('{Y}', '20')

        setTimeout(() => {
          // se è ancora DANGER la resetto
          setFileState(prev => ({
            ...prev,
            variant: UPLOADER_VARIANT_DEFAULT
          }))
        }, 5000)
      }
    }
  }, [file])

  useEffect(() => {
    variant === UPLOADER_VARIANT_UPLOADING && uploadFile()
  }, [variant])

  return (
    <>
      <FormElement
        required
        disabled
        labelFor='messageNote'
        label={intl.formatMessage({
          id: 'Load.EmailMessageImport.ImportFileLabel'
        })}
      >
        <Uploader
          multiple={false}
          variant={variant}
          accept={FILE_ACCEPT}
          onChange={e => {
            setFileState(prev => ({
              ...prev,
              isDirty: true,
              file: e && e.length > 0 ? e[0] : {}, // {} oggetto vuoto scatena il danger dello useEffect,
              extension: e && e.length > 0 ? getExtension(e[0].name) : ''
            }))
          }}
          inputId='input-email-file-id'
          value={value}
          hint={hint}
        >
          {defaultInner}
        </Uploader>
      </FormElement>
    </>
  )
}

export default InputFile
